const navData = {
	list: [
		{
			id: 2,
			icon: '',
			title: '法规标准库',
			href: '/StandardsList'
		},
		{
			id: 1,
			icon: '',
			title: 'AI-行业大模型',
			class: 'nav-aiimg',
			href: '/ai'
		},
		// {
		// 	id: 5,
		// 	icon: '',
		// 	title: '智能工具',
		// 	desc: '专业评审与合规审查智能化解决方案',
		// 	always: true,
		// 	children: [
		// 		{
		// 			key: 'review',
		// 			title: '鉴定评审智能辅助系统（企业版）',
		// 			desc: '智能化模拟评审流程，高效准确',
		// 			badge: '热门',
		// 			badgeClass: 'badge-hot',
		// 			icon: 'el-icon-folder-checked',
		// 			iconClass: 'skill-icon-blue'
		// 		},
		// 		{
		// 			// compliance：总入口据此判定账户等级并直跳合规系统（非 VIP/旗舰版则落到子站提示）
		// 			key: 'compliance',
		// 			title: '文件合规审查系统',
		// 			desc: '智能文档分析与合规审查 · Agent 驱动',
		// 			badge: '上新',
		// 			badgeClass: 'badge-new',
		// 			icon: 'el-icon-finished',
		// 			iconClass: 'skill-icon-green'
		// 		},
		// 	]
		// },

		// {
		// 	id: 3,
		// 	icon: '',
		// 	title: '个人书架',
		// 	href: '/BookCenter/BookList'
		// },
		// {
		// 	id: 4,
		// 	icon: '',
		// 	title: '网上书城',
		// 	href: '/Cart'
		// },
	]
};

export default navData;
